import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'box-loading',
  templateUrl: './box-loading.component.html',
  styleUrls: ['./box-loading.component.css']
})
export class BoxLoadingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
